import {
  APP,
  MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  MESSAGE_GRID_HEADER_COLOR
} from 'src/style/variable';

export const guarantorHeaderStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '10%',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  height: '2rem',
  lineHeight: '0rem'
};

export const guarantorCellStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '10%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};

export const patientsHeaderStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '10%',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  height: '2rem',
  lineHeight: '0rem'
};

export const patientsCellStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '10%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};

export const messageHeaderStyle = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '37%',
  height: '2rem',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  lineHeight: '0rem'
};

export const messageCellStyle = {
  fontFamily: APP.FONT_FAMILY.REGULAR,
  width: '37%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};

export const assignToHeaderStyle = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '15%',
  height: '2rem',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  lineHeight: '0rem'
};

export const assignToCellStyle = {
  fontFamily: APP.FONT_FAMILY.REGULAR,
  width: '15%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};

export const statusHeaderStyle = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '15%',
  height: '2rem',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  lineHeight: '0rem'
};

export const statusCellStyle = {
  fontFamily: APP.FONT_FAMILY.REGULAR,
  width: '15%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};

export const actionsHeaderStyle = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '15%',
  // textAlign: 'center',
  height: '2rem',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  lineHeight: '0rem'
};

export const actionsCellStyle = {
  fontFamily: APP.FONT_FAMILY.REGULAR,
  width: '15%',
  fontSize: '0.875rem',
  textAlign: 'center',
  padding: '0.5rem'
};

export const messageGridTableStyle = {
  margin: '2rem',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  boxShadow: '0 0 0 1px rgb(63 63 68 / 5%), 0 1px 3px 0 rgb(63 63 68 / 15%)',
  cursor: 'pointer'
};
export const fromHeaderStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '33%',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  height: '2rem',
  lineHeight: '0rem'
};

export const fromCellStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '33%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};

export const messageSectionHeaderStyles = {
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  width: '33%',
  backgroundColor: MESSAGE_GRID_HEADER_BACKGROUND_COLOR,
  color: MESSAGE_GRID_HEADER_COLOR,
  fontSize: '0.875rem',
  padding: '0.7rem',
  height: '2rem',
  lineHeight: '0rem'
};

export const messageSectionCellStyles = {
  fontFamily: APP.FONT_FAMILY.REGULAR,
  width: '33%',
  fontSize: '0.875rem',
  padding: '0.7rem'
};
